export default {
  name: 'AuditListExpand',
  props: {
    data: Object
  }
}
